export default class CennikOptionsService{

  constructor(server){
    this.server = server;
  }

  list(){
    return this.server("listCenaTyp");
  }

  save(item){
    return this.server("saveCenaTyp", {nazov: item.nazov, jednotka: item.jednotka});
  }

  remove(item){
    return this.server("removeCenaTyp", {id: item.id});
  }

  update(item){
    return this.server("saveCenaTyp", {id: item.id, nazov: item.nazov, jednotka: item.jednotka});
  }


}


// WEBPACK FOOTER //
// ./src/services/CennikOptionsService.js